// extracted by mini-css-extract-plugin
export var newsguideContainer = "news-guide-module--newsguideContainer--98be1";
export var resultColumnContainer = "news-guide-module--resultColumnContainer--17cac";
export var resultContainer = "news-guide-module--resultContainer--53165";
export var resultListContainer = "news-guide-module--resultListContainer--db660";